function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.34 26a1.41 1.41 0 01-1.415-1.41v-8.744h-6.51A1.412 1.412 0 010 14.436c0-.779.633-1.41 1.415-1.41h7.924c.782 0 1.416.631 1.416 1.41v5.378l9.849-15.17c.341-.525.99-.763 1.59-.586a1.41 1.41 0 011.014 1.352v7.616h5.377c.781 0 1.415.631 1.415 1.41 0 .779-.634 1.41-1.416 1.41h-6.792a1.412 1.412 0 01-1.415-1.41v-4.25l-9.85 15.17c-.266.409-.717.644-1.188.644z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "4",
  width: "30",
  height: "22"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.34 26a1.41 1.41 0 01-1.415-1.41v-8.744h-6.51A1.412 1.412 0 010 14.436c0-.779.633-1.41 1.415-1.41h7.924c.782 0 1.416.631 1.416 1.41v5.378l9.849-15.17c.341-.525.99-.763 1.59-.586a1.41 1.41 0 011.014 1.352v7.616h5.377c.781 0 1.415.631 1.415 1.41 0 .779-.634 1.41-1.416 1.41h-6.792a1.412 1.412 0 01-1.415-1.41v-4.25l-9.85 15.17c-.266.409-.717.644-1.188.644z",
  fill: "currentColor"
}))));